import { useState } from 'react';
import { MessageSquareWarning } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { FeedbackDialog } from '@/components/FeedbackDialog';

interface BetaBannerProps {
  newsId?: string;
}

export function BetaBanner({ newsId }: BetaBannerProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="w-full bg-muted/60 border-b border-border/50 text-sm">
        <div className="container flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 py-2">
          <p className="text-muted-foreground">
            <span className="font-semibold text-foreground">Beta</span>{' '}
            PharmaRadar is currently in Beta. Data may be incomplete or imperfect as we rapidly improve ranking and summarization. Please report any issues — your feedback helps us improve faster.
          </p>
          <Button
            variant="default"
            size="sm"
            className="shrink-0 gap-1.5"
            onClick={() => setOpen(true)}
          >
            <MessageSquareWarning className="h-4 w-4" />
            Report Issue
          </Button>
        </div>
      </div>
      <FeedbackDialog open={open} onOpenChange={setOpen} newsId={newsId} />
    </>
  );
}
